// Created by carsonaberle at 11/23/21
export const title = 'Change service type';
export const onChangeTypeString = 'Updated service type!';
